import { LoginView as UILoginView, useHead } from '@mybonus/ui';

export function LoginView() {
	useHead({ subtitle: 'Logga in' });

	return <UILoginView />;
}
